import Row from "./row";

Row.install = function install(Vue) {
  Vue.component(Row.name, Row);
};

export default Row;
